import React, {ReactNode} from 'react';

import {BLUE_LIGHTER, GRAY_DARK, RED} from 'ui-library/Colors';

interface MarkerProps {
  id: string;
  className?: string;
  children: ReactNode;
}

const Marker = ({id, children}: MarkerProps): JSX.Element => (
  <marker
    className="react-flow__arrowhead"
    id={id}
    markerWidth="15"
    markerHeight="15"
    viewBox="-10 -10 20 20"
    orient="auto"
    markerUnits="userSpaceOnUse"
    refX="0"
    refY="0"
  >
    {children}
  </marker>
);

export enum MarkerEndId {
  INVALID_MATERIAL_EDGE_MARKER = 'invalid-material-edge-marker',
  VALID_EDGE_MARKER = 'valid-edge-marker',
  SELECTED_MATERIAL_EDGE_MARKER = 'selected-material-edge-marker',
}

interface ProcedureMarkerDefinitionsProps {
  id: MarkerEndId;
  color: string;
  strokeWidth: number;
}

export function ProcedureMarkerDefinition({
  color,
  id,
  strokeWidth,
}: ProcedureMarkerDefinitionsProps): JSX.Element {
  return (
    <svg>
      <defs>
        <Marker id={id}>
          <polyline
            style={{
              stroke: color,
              strokeWidth,
            }}
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
            points="-5,-4 0,0 -5,4"
          />
        </Marker>
      </defs>
    </svg>
  );
}

export const EDGE_END_MARKER_DEFINITIONS = (
  <div>
    <ProcedureMarkerDefinition id={MarkerEndId.VALID_EDGE_MARKER} color={GRAY_DARK} strokeWidth={1.5} />
    <ProcedureMarkerDefinition id={MarkerEndId.INVALID_MATERIAL_EDGE_MARKER} color={RED} strokeWidth={2} />
    <ProcedureMarkerDefinition
      id={MarkerEndId.SELECTED_MATERIAL_EDGE_MARKER}
      color={BLUE_LIGHTER}
      strokeWidth={2}
    />
  </div>
);
